import client from './client';

export const cognitoLogin = (token) =>
  client.post('/auth/cognito-login', {}, {
    headers: { Authorization: `Bearer ${token}` },
    skipDeduplication: true,
  }).then((r) => r.data);

export const changePassword = (data) =>
  client.post('/auth/change-password', data).then((r) => r.data);

// Start the branded, token-backed reset. The backend emails a reset LINK
// via SES and always returns a generic success (no account enumeration).
export const forgotPassword = (email) =>
  client.post('/auth/forgot-password', { email }).then((r) => r.data);

// Complete the reset using the single-use token from the emailed link.
export const confirmPasswordReset = (token, newPassword) =>
  client
    .post('/auth/reset-password', { token, new_password: newPassword })
    .then((r) => r.data);

export const signout = (accessToken) =>
  client.post('/auth/signout', { access_token: accessToken }).then((r) => r.data);
